import { combineReducers } from 'redux';

import calculators from './calculators.reducer';
import conditionCategories from './conditionCategories.reducer';
import conditions from './conditions.reducer';
import conditionSets from './conditionSets.reducer';
import documentExpirationDates from './documentExpirationDates.reducer';
import documentExpirationSettings from './documentExpirationSettings.reducer';
import priorTo from './priorTo.reducer';
import programLoan from './programLoan.reducer';
import ruleActions from './ruleActions.reducer';
import ruleCategories from './ruleCategories.reducer';
import ruleGroups from './ruleGroups.reducer';
import rulePreviews from './rulePreviews.reducer';
import rules from './rules.reducer';
import ruleSchema from './ruleSchema.reducer';
import searchSynonyms from './searchSynonyms.reducer';
import settings from './settings.reducer';
import slaGroups from './slaGroups.reducer';

const reducer = combineReducers({
  documentExpirationDates,
  ruleGroups,
  rules,
  ruleSchema,
  ruleActions,
  rulePreviews,
  calculators,
  conditionCategories,
  priorTo,
  programLoan,
  conditions,
  conditionSets,
  ruleCategories,
  searchSynonyms,
  settings,
  slaGroups,
  documentExpirationSettings,
});

export default reducer;
